/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/figma" */ '@atlassian/logo-third-party/figma'
		).then((m) => m.FigmaIcon),
	{ moduleId: '@atlassian/logo-third-party/figma' },
);

const LazyFigmaIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-figma" */ './utils').then((m) => m.FigmaIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/figma/icon' },
);

const LazyFigmaSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-figma-search-result" */ './utils').then(
			(m) => m.FigmaSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/figma/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const FigmaIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyFigmaIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const FigmaSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyFigmaSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
